module.exports = __webpack_public_path__ + "static/media/chicken.b49b7192.jpg";